import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWpInstanceStatus } from '../store/slices/wpConfigSlice';

/**
 * WpStatusPoller - WhatsApp durumunu otomatik olarak kontrol eder
 * 
 * Özellikler:
 * - Bağlı değilse her 2 saniyede bir kontrol eder (QR okutma için)
 * - Bağlıysa her 30 saniyede bir kontrol eder (bağlantı kopması kontrolü için)
 * - Kullanıcı logout olduğunda veya branch değiştiğinde temizlenir
 */
const WpStatusPoller = () => {
  const dispatch = useDispatch();
  const { isLogged, token } = useSelector((state) => state.auth);
  const selectedBranch = useSelector((state) => state.branches.selectedBranch);
  const { instance } = useSelector((state) => state.wpConfig);

  const wpStatus = instance?.status || null;
  const isConnected = wpStatus?.status === 'connected';

  useEffect(() => {
    if (!isLogged || !token || !selectedBranch?.id) return;

    // İlk yüklemede kontrol et
    dispatch(fetchWpInstanceStatus(selectedBranch.id));

    // Bağlı değilse daha sık kontrol et (QR okutma için)
    // Bağlıysa daha seyrek kontrol et (bağlantı kopması kontrolü için)
    const interval = isConnected ? 30000 : 10000; // 30s veya 10s

    const intervalId = setInterval(() => {
      dispatch(fetchWpInstanceStatus(selectedBranch.id));
    }, interval);

    return () => clearInterval(intervalId);
  }, [dispatch, isLogged, token, selectedBranch?.id, isConnected]);

  return null;
};

export default WpStatusPoller; 